import { WorkspacePlaceholder } from './WorkspacePlaceholder';
import { WorkspaceShell } from './WorkspaceShell';

export function ReportsWorkspace(): JSX.Element {
  return (
    <WorkspaceShell title="Reportes" status="future">
      <WorkspacePlaceholder
        title="Reportes"
        description="Generar mapas, tableros, informes y exportaciones tecnicas o ejecutivas del proyecto."
        capabilities={[
          'Informes territoriales',
          'Exportacion PDF y CSV',
          'Mapas de salida',
          'Tableros ejecutivos',
          'Resumen por proyecto o zona',
        ]}
      />
    </WorkspaceShell>
  );
}
